// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#column-index[data-v-c1946468]{display:flex;justify-content:space-between;margin:auto;width:1200px}#column-index .layout-main-body[data-v-c1946468]{width:834px;padding-right:22px}#column-index .layout-main-body .column-article[data-v-c1946468]{margin-top:20px}#column-index .layout-main-aside[data-v-c1946468]{width:316px;margin-top:20px;margin-bottom:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
